module.exports = __webpack_public_path__ + "media/svg/MagnifyingGlassDocument-6fa2f6bb.svg";